RA.EmailNotifications = {
  init() {
    this.setVariables();

    let url = `${Config.contextPath}/controller/get/mysubscriptions/`;
    $.get(url)
      .done(r => {
        this.solutions = r.kb;
        this.pageSize = r.pageSize;

        if (r.community) {
          this.discussions = r.community.discussions;
          this.topics = r.community.topics;
          this.communities = r.community.communities;
        }

        this.refreshLists();
        this.refreshEdit();
      });
  },
  setVariables() {
    this.solutions = [];
    this.discussions = [];
    this.topics = [];
    this.communities = [];
    this.showEditControls = false;
  },
  editClicked() {
    this.showEditControls = !this.showEditControls;
    this.refreshLists();
    this.refreshEdit();
  },
  deleteKBClicked(sub) {
    let solutions = this.solutions;
    let index = solutions.indexOf(sub);

    let url = `${Config.contextPath}/controller/delete/mysubscriptions/`;
    let data = {
      solutionID: sub.solutionID,
      SToken: Config.csrf.value
    };

    $.post(url, data);

    // optimistic remove from array
    solutions.splice(index, 1);
    this.refreshLists();
    this.refreshEdit();
  },
  deleteCommClicked(sub) {
    let {
      discussions,
      topics,
      communities
    } = this;
    let type = this.getItemType(sub);
    let url = `${Config.contextPath}/controller/delete/mysubscriptions/`;
    let data;

    if (type == "discussion") {
      data = { discussionID: sub.discussionID };
      discussions.splice(discussions.indexOf(sub), 1);
    } else if (type == "topic") {
      data = { topicID: sub.topicID };
      topics.splice(topics.indexOf(sub), 1);
    } else {
      data = { communityID: sub.communityID };
      communities.splice(communities.indexOf(sub), 1);
    }

    data.SToken = Config.csrf.value;

    $.post(url, data);

    this.refreshLists();
    this.refreshEdit();
  },
  getItemType(sub) {
    if (sub.solutionID) {
      return "solution";
    } else if (sub.discussionID) {
      return "discussion";
    } else if (sub.topicID) {
      return "topic";
    } else if (sub.communityID) {
      return "community";
    }
  },
  renderKBItem(sub) {
    return (
      <EditableListItem
        key={sub.solutionID}
        showDelete={this.showEditControls}
        onDelete={this.deleteKBClicked.bind(this, sub)}>
        <a href={`${Config.contextPath}/app/portlets/results/viewsolution.jsp?solutionid=${sub.solutionID}`}>{sub.title}</a>
      </EditableListItem>
    )
  },
  renderCommItem(sub) {
    let type = this.getItemType(sub);

    let href, text;
    if (type == "discussion") {
      href = `controller/view/discussion/${sub.discussionID}`;
      text = sub.title;
    } else if (type == "topic") {
      href = `${Config.portalInterface}/?tabname=community&topicID=${sub.topicID}&communityID=${sub.communityID}`;
      text = `${sub.community} > ${sub.topic}`;
    } else if (type == "community") {
      href = `${Config.portalInterface}/?tabname=community&communityID=${sub.communityID}`;
      text = sub.community;
    }

    return (
      <EditableListItem
        showDelete={this.showEditControls}
        key={sub.id}
        onDelete={this.deleteCommClicked.bind(this, sub)}>
        <a href={`${Config.contextPath}/${href}`}>{text}</a>
      </EditableListItem>
    )
  },
  refreshEdit() {
    let link = (
      <EditLinkToggle
        onClick={this.editClicked.bind(this)}
        editEnabled={this.showEditControls} />
    );

    if (this.solutions.length == 0 &&
      this.discussions.length == 0 &&
      this.communities.length == 0 &&
      this.topics.length == 0) link = <span />;

    ReactDOM.render(
      link,
      document.getElementById("editSubToggle")
    );
  },
  refreshLists() {
    let solutionSub = this.solutions.length ?
      <BasicPagerList
        className="bullet-list"
        items={this.solutions}
        renderItem={this.renderKBItem.bind(this)} /> :
      <NoContent message={Labels.getLabel("Not subscribed to any solutions")} />;

    let discussionSub = this.discussions.length ?
      <BasicPagerList
        className="bullet-list"
        pageSize={this.pageSize}
        items={this.discussions}
        renderItem={this.renderCommItem.bind(this)} /> :
      <NoContent message={Labels.getLabel("Not subscribed to any discussions")} />;

    let topicSub = this.topics.length ?
      <BasicPagerList
        className="bullet-list"
        pageSize={this.pageSize}
        items={this.topics}
        renderItem={this.renderCommItem.bind(this)} /> :
      <NoContent message={Labels.getLabel("Not subscribed to any topics")} />;

    let communitySub = this.communities.length ?
      <BasicPagerList
        className="bullet-list"
        pageSize={this.pageSize}
        items={this.communities}
        renderItem={this.renderCommItem.bind(this)} /> :
      <NoContent message={Labels.getLabel("Not subscribed to any communities")} />;

    ReactDOM.render(
      solutionSub,
      document.getElementById("solutionSub")
    );

    if (Config.isCommunityEnabled) {
      ReactDOM.render(
        discussionSub,
        document.getElementById("discussionSub")
      );

      ReactDOM.render(
        topicSub,
        document.getElementById("topicSub")
      );

      ReactDOM.render(
        communitySub,
        document.getElementById("communitySub")
      );
    }
  }
};